import React from 'react';
import Link from '@atlaskit/link';
import { useLocation } from 'react-router-dom';
import { useRegisterComponent } from '../../orchestrator';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
};

export const ResetPasswordLink = ({ children, onClick }: Props) => {
  useRegisterComponent(ResetPasswordLink.name);

  const { search } = useLocation();

  return (
    <Link href={'/login/resetpassword' + search} id="resetPassword" onClick={onClick}>
      {children}
    </Link>
  );
};
